import EnvelopeIcon from "../../../assets/icons/EnvelopeIcon";
import { PhoneIcon } from "../../../assets/icons/PhoneIcon";
import MappinIcon from "../../../assets/icons/MappinIcon";
import WhatsAppIcon from "assets/images/whatsapp.svg";
import MailboxIcon from "assets/icons/MailboxIcon";

const Address = () => {
    return (
        <>
            <div className="flex flex-col gap-2">
                <div className="flex gap-2 items-center">
                    <EnvelopeIcon className="h-6 w-6 text-primary" />
                    <a
                        href="mailto:info@adroitsystems.io"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        info@adroitsystems.ae
                    </a>
                </div>
                <div className="flex gap-2 items-center">
                    <img
                        src={WhatsAppIcon}
                        alt="WhatsApp"
                        className="h-6 w-6"
                    />
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://wa.me/971585237648?text=Hi%2C%0AI%27m%20in%20need%20of%20IT%20services."
                    >
                        +971 585 (ADROIT)
                    </a>
                </div>
                <div className="flex gap-2 items-center">
                    <PhoneIcon className="h-6 w-6 text-primary" />
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="tel:+971 4 3939 231"
                    >
                        +971 4 3939 231
                    </a>
                </div>
                <div className="flex gap-2 items-center">
                    <MailboxIcon className="h-6 w-6 text-primary" />
                    <a target="_blank" rel="noreferrer" href="#">
                        PO Box 944871
                    </a>
                </div>
                <div className="flex gap-2 items-start">
                    <MappinIcon className="h-6 w-6 shrink-0 text-primary" />
                    <span className="text-sm text-secondary/80">
                        6th Floor, Grandstand <br /> Meydan Free Zone <br />{" "}
                        Dubai, UAE.
                    </span>
                </div>
            </div>
            <div></div>
        </>
    );
};

export default Address;
